import { createSelector, createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from '../common/reducers/utilities';
import { ensureArray } from '../common/utils/arrayUtilities';


const stdReplySlice = createSlice({
    name: 'stdReplies',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload
        },
        addOrUpdate: (state, action) => {
            for (const r of ensureArray(action.payload)) {
                let idx = state.data.findIndex(r2 => r2.id === r.id);
                if (idx >= 0) {
                    state.data.splice(idx, 1, r);
                } else {
                    state.data.push(r);
                }
            }
        },
        remove: (state, action) => {
            for (const r of ensureArray(action.payload)) {
                let idx = state.data.findIndex(r2 => r.id === r2.id);
                if (idx >= 0) {
                    state.data.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => stdReplySlice.getInitialState());
    }
});

// #region network operations
const fetchStdReplies = network => network.get('/api/v1/standardReplies', stdReplySlice.actions.set);
export const addStdReply = (network, data) => network.post('/api/v1/standardReplies', data, stdReplySlice.actions.addOrUpdate); // TODO better failure
export const removeStdReply = (network, id) => network.delete('/api/v1/standardReplies/' + encodeURIComponent(id), stdReplySlice.actions.remove); // TODO better failure
// #endregion

// #region permission checks
export const canCreateStdReply = (credentials, reply) => credentials.access.hasFull('administrator');
export const canRemoveStdReply = (credentials, reply) => credentials.access.hasFull('administrator');
// #endregion

// #region selectors
const selectAllStdReplies = state => state.stdReplies.data;

// we now make a reselect to memoize a select function parameterized by jobid and expose that factory through a convenience function
const selectRepliesByKind = createSelector([selectAllStdReplies, (replies, kind) => kind], (replies, kind) => replies.filter(r => !r.kind || r.kind === kind));
const selectStdReplies = kind => state => selectRepliesByKind(state, kind);
// #endregion

export const [useStdRepliesByKind] = dataHookFactory(selectStdReplies, origin => ({ run: fetchStdReplies}));
export const [useStdReplies] = dataHookFactory(selectAllStdReplies, ({ run: fetchStdReplies }));

const reducerDetails = { name: stdReplySlice.name, reducer: stdReplySlice.reducer };
export default reducerDetails;